import { MISCELLANEOUS_RESOURCES, PAGE_NAMES, ACTION } from 'constant';
import { IMakeActionList } from '../kindReward.model';

export const makeActionList = (params: any): IMakeActionList => {
	const { hasPermissionV2 } = params;

	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'Credit Kind Rewards',
				id: 'credit',
				isEnabled: () => {
					return hasPermissionV2({
						configPageName: PAGE_NAMES.miscellaneous,
						configResourceName: MISCELLANEOUS_RESOURCES.kindReward,
						configActionName: ACTION.creditKindRewards
					});
				}
			}
		]
	};
};

export default {
	makeActionList
};
